import { getUsersByCompanyId } from "@/requests/users/users-by-company.request";
import { useQuery } from "@tanstack/react-query";

export const useUsersByCompany = (companyId: string) => {
  return useQuery({
    queryKey: ["companies", companyId, "users"],
    queryFn: () => getUsersByCompanyId({ companyId, q: "", size: 200 }),
  });
};
